<template>
  <v-container class="white-wrapper" fluid>
    <div class="config-title" style="max-width: 25rem; margin: 0 auto">
      <router-link to="/config" class="back-icon">
        <v-btn icon large>
          <img class="back-svg" src="@/assets/icon/arrow(back).svg" />
        </v-btn>
      </router-link>
      <div class="text-h6 font-weight-bold">{{$t('config.PaymentHistory')}}</div>
    </div>
    <div class="panels-container">
      <template v-if="list.length === 0">
        <div class="item-wrapper justify-center">{{$t('config.PaymentHistoryNone')}}</div>
      </template>
      <template v-else>
        <template v-for="(item, idx ) in list">
          <v-card
            :key="item.up_id"
            class="shadow-10-30"
            style="padding: 1.3rem; margin-bottom: 1.3rem"
            v-if="!isLoading || list.length !== 0"
          >
            <div class="my-2">
              <div class="type-wrapper">
                <div class="date-wrapper mb-1">
                  {{
                    $moment(item.up_created_at).format('YYYY-MM-DD HH:mm:ss')
                  }}
                </div>
                <template v-if="item.up_type === 0">
                  <div style="color: #f65b5b">
                    {{ item.up_type_txt }}
                  </div>
                </template>
                <template v-else>
                  <div style="color: #4472d9">
                    {{ item.up_type_txt }}
                    
                  </div>
                </template>
              </div>
              <div class="type-wrapper">
                <div>
                  {{ item.up_shop2 }}
                </div>
                <div>
                  <img style="position: relative;top: 4px;width:20px;" :src="imgSrc(item.token_type)" />

                  {{ comma(item.up_point) + item.token_type }}
                </div>
              </div>
              <div class="type-wrapper">
                <div class="content-wrapper">
                  {{ item.up_content }}<br>
                  {{item.b_target  }}
                  <!-- {{o2PosSrc(item.up_content)}} -->
                </div>
              </div >
              <!--
              <template v-if="o2PosSrc(item.up_content) != null" >
                  <div> 
                    VIEW                     
                  </div>
              </template>
              -->
            </div>
          </v-card>
        </template>
      </template>

      <div class="d-flex justify-center align-center" style="min-height: 2rem">
        <v-btn
          v-show="!noMore"
          @click="getMore"
          color="primary"
          class="font-weight-bold"
          text
        >
          {{ $t('point.more') }}
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      o2list : {} , 
      noMore: false,
      page: 1,
      size: 20
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters.loading
    }
  },
  created() {
    this.$store.commit('loading', true)
    this.callAPI()
  },
  methods: {
    o2PosSrc( itemName ) {
      
       if(!itemName) return null ; 
          itemName  = itemName.toUpperCase().replace(/ /g, '');  
          if( this.o2list[itemName]) return this.o2list[itemName] 
          else return null  
 
    },    
    imgSrc(item) {
      let src
      try {
        src = require(`@/assets/svg/${item + '-logo.svg'}`)
      } catch (e) {
        try {
          src = require(`@/assets/svg/${item + '-logo.png'}`)
        } catch (e) {
          src = require(`@/assets/svg/ETH-logo.svg`)
        }
      }
      return src
    },
    callAPI() {
      const params = {
        page: this.page,
        size: this.size
      }
      this.$store.commit('loading', true)
      this.$store
        .dispatch('my_point_history', params)
        .then((res) => {
          this.$store.commit('loading', false)
          if (res.status === 200 && res.data.result[0].length > 0) {
            
            const arr = res.data.result[0]
            this.list = this.list.concat(arr)
            
            // 이미지 리스트 
            res.data.o2lists[0].map((item) => {
              let {nlink , upper_ntext , lower_ntext } = item ; 
                // console.log( nlink , upper_ntext , lower_ntext  ) ;         
              this.o2list[upper_ntext] = nlink ; 
            }) ; 


   // console.log( "ssssssssssssss:: " ,te ,  te['SPECIALFORCEPSG-1s']  ); 

            if ( arr.length < this.size) this.noMore = true
          } else if (res.data.result[0].length === 0) {
            this.noMore = true
          } else throw res
        })
        .catch((err) => {
          this.$store.commit('loading', false)
          this.$store.dispatch('toast', {
            toast: true,
            toast_msg: this.$t('errorServer'),
            timeout: 2000
          })
          // console.log(err)
        })
    },
    getMore() {
      this.page = this.page + 1
      this.callAPI()
    }
  }
}
</script>

<style scoped>
.item-wrapper {
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.85rem;
  min-height: 3rem;
}
.date-wrapper {
  font-size: 0.8rem;
  color: #cbcbcb;
  font-weight: 500;
}
.type-wrapper {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}
.content-wrapper {
  font-size: 0.9rem;
  display: flex;
  justify-content: flex-end;
}
.unpaid-text {
  text-decoration: underline;
  text-underline-offset: 3px;
}
</style>
